import { useEffect } from "react";

const DEFAULT_TITLE = "Apicoltura DePiccoli - Miele Artigianale";
const DEFAULT_DESCRIPTION =
	"Apicoltura DePiccoli - Miele artigianale di qualità superiore. Scopri i nostri prodotti naturali direttamente dall'alveare.";

const SITE_URL = "https://apicolturadepiccoli.it";

function setCanonical(href: string) {
	let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
	if (!link) {
		link = document.createElement("link");
		link.rel = "canonical";
		document.head.appendChild(link);
	}
	link.href = href;
}

function setMetaTag(attr: "name" | "property", key: string, content: string) {
	let tag = document.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
	if (!tag) {
		tag = document.createElement("meta");
		tag.setAttribute(attr, key);
		document.head.appendChild(tag);
	}
	tag.setAttribute("content", content);
}

/**
 * Aggiorna i meta tag durante la navigazione nell'app. Il primo caricamento
 * di ogni pagina pubblica arriva già con i tag giusti da scripts/prerender.js;
 * questo hook li tiene coerenti quando si cambia pagina senza ricaricare.
 * `noindex` per pagine come la 404, che non devono finire nei risultati.
 */
export function useDocumentMeta(title?: string, description?: string, options?: { noindex?: boolean }) {
	const noindex = !!options?.noindex;
	useEffect(() => {
		const url = SITE_URL + window.location.pathname;
		setCanonical(url);
		setMetaTag("property", "og:url", url);
		setMetaTag("name", "robots", noindex ? "noindex, follow" : "index, follow");
		document.title = title ? `${title} | Apicoltura DePiccoli` : DEFAULT_TITLE;
		setMetaTag("name", "description", description || DEFAULT_DESCRIPTION);
		setMetaTag("property", "og:title", title ? `${title} | Apicoltura DePiccoli` : DEFAULT_TITLE);
		setMetaTag("property", "og:description", description || DEFAULT_DESCRIPTION);

		return () => {
			document.title = DEFAULT_TITLE;
			setMetaTag("name", "description", DEFAULT_DESCRIPTION);
			setMetaTag("property", "og:title", DEFAULT_TITLE);
			setMetaTag("property", "og:description", DEFAULT_DESCRIPTION);
			setMetaTag("name", "robots", "index, follow");
		};
	}, [title, description, noindex]);
}
